import { Component, Inject } from '@angular/core';
import { AuthenticationService, CONFIG_ENV } from '@core/service';
import { IEnvironmentVariables } from 'src/environments/IEnvironment';
import { SecurityService } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'referral-welcome-page',
    templateUrl: './referral-welcome-page.component.html',
    styleUrls: ['./referral-welcome-page.component.scss'],
    standalone: false
})
export class ReferralWelcomePageComponent {

  constructor(
    @Inject('windowRef') private window: Window,
    @Inject(CONFIG_ENV) private configEnv: IEnvironmentVariables,
    private readonly authenticationService: AuthenticationService,
    private readonly securityService: SecurityService
  ) { }

  openReferralDashboard() {
    this.window.open(this.configEnv.sdohUrl);
  }

  get isReferralDashboardHidden(): boolean {
    if(!this.isWCCExternal && !this.isSDoHorReferralProgramAdmin){
      return false;
    }
    return true;
  }

  get isWCCExternal(): boolean {
    return this.authenticationService.isWCCExternal;
  }

  get isSDoHorReferralProgramAdmin(): boolean {
    return this.authenticationService.isSdohUserExternal
    || this.authenticationService.isReferralProgramProviderAdmin
      || this.isWCCExternal;
  }
}
